import { render, staticRenderFns } from "./MediaDisplayerTabs.vue?vue&type=template&id=73d5e286&scoped=true"
import script from "./MediaDisplayerTabs.vue?vue&type=script&lang=js"
export * from "./MediaDisplayerTabs.vue?vue&type=script&lang=js"
import style0 from "./MediaDisplayerTabs.vue?vue&type=style&index=0&id=73d5e286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d5e286",
  null
  
)

export default component.exports